import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { PsfPromoteOrSharePagePrefetchedDataProps } from 'src/app/pages/psf/promoteOrShare/pageContext';
import {
	prefetchPageContext,
	PsfPromoteOrSharePageContextProvider,
} from 'src/app/pages/psf/promoteOrShare/pageContext';

import { Layout } from '../layout';

import { PsfPromoteOrShareErrorHandler } from './ErrorHandler';

export const PsfPromoteOrShare = withPrefetchedData(
	function PsfPromoteOrShare({ prefetchedData }: PsfPromoteOrSharePagePrefetchedDataProps): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<PsfPromoteOrSharePageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={PsfPromoteOrShareErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</PsfPromoteOrSharePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
